import { render, staticRenderFns } from "./groceries.vue?vue&type=template&id=30a5b9ca&scoped=true"
import script from "./groceries.vue?vue&type=script&lang=js"
export * from "./groceries.vue?vue&type=script&lang=js"
import style0 from "./groceries.vue?vue&type=style&index=0&id=30a5b9ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a5b9ca",
  null
  
)

export default component.exports